module.exports = __webpack_public_path__ + "img/icon_FLOTILLA.93e7ec98.svg";